export default __webpack_public_path__ + "static/MediaContentSixFancybox-a6e43c6130a9a88a7b02d59f3ba443c6.webp";